import React from "react"
import { Button, ButtonGroup, ButtonToolbar } from 'react-bootstrap'
import { range, isArray, isNumber, isFunction, get } from "lodash"
import PropTypes from "prop-types"
import { products, restaurants } from "../../../../../data"

const _tl = {
  car: "Driver",
  restaurant: "Restaurant menus",
  table: "Restaurant table",
  onedaytrip: "1-day trip",
  ticket: "Tickets",
}

export const typeLabel = (k) => (_tl[k] || k)

export const reservationName = r => (
  get(r, "product.name")
  || get(r, "product.spanishname")
  || get(products, [r.restaurant, "name"])
  || get(r, "ticket.name")
  || get(r, "onedaytrip.name")
  || (r.type == "car" && (
    `${r.destinationZone}: ${r.destinationPlace}`
  ))
  || "ERROR"
)

export const Pager = ({
  numPages, page, onChange,
  sizes, size, onSizeChange,
  style
}) => (
  <ButtonToolbar style={style || {}}>
    {
      sizes && size && onSizeChange && (
        <ButtonGroup>
          {
            sizes.map(s => (
              <Button
                key={s}
                active={s == size}
                onClick={() => onSizeChange(s)}
              >
                {s}
              </Button>
            ))
          }
        </ButtonGroup>
      )
    }
    <ButtonGroup>
      {
        range(0, numPages).map(n => (
          <Button
            key={n}
            active={n == page}
            onClick={() => onChange(n)}
          >
            {n + 1}
          </Button>
        ))
      }
    </ButtonGroup>
  </ButtonToolbar>
)

const sizeProps = typeChecker => (props, propName) => {
  if (props.size || props.sizes || props.onSizeChange) {
    if (!props[propName]) {
      return new Error(
        `prop ${propName} required if size/sizes/onSizeChange are provided`
      )
    }
    if (!typeChecker(props[propName])) {
      return new Error(
        `prop ${propName} is the wrong type`
      )
    }
  }

}

Pager.propTypes = {
  // pages
  numPages: PropTypes.number.isRequired,
  page: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,

  // sizes
  size: sizeProps(isNumber),
  sizes: sizeProps(isArray),
  onSizeChange: sizeProps(isFunction),

  // other
  style: PropTypes.object
}

Pager.defaultProps = {
  style: {},
  size: null,
  sizes: null,
  onSizeChange: null,
}



// WEBPACK FOOTER //
// ./src/app/admin/components/tables/table.aux.js